import {
  PlusCircleTwoTone, ReloadOutlined, SaveOutlined
} from '@ant-design/icons';
import { Button, Input, message, Popconfirm, Space } from 'antd';
import _ from 'lodash';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateStockPrice } from '../../productmanagement/services/kogan-products-service';
import {
  clearDirtyProducts, fetchProducts, getDirtyProducts, isLoading,
  selectAllProductData
} from '../../productmanagement/slices/productsSlice';
import { fetchImagesInFolder } from '../slices/productImagesSlice';
import { addTab, createTab, setActiveTab, TAB_TYPE_ENUM } from '../slices/tabsSlice';
function ButtonContainer() {
  const [sku, setSku] = useState('');
  const dispatch = useDispatch();
  const fetchStatus = useSelector(isLoading);
  const products = useSelector(selectAllProductData);
  const gridDirtyProducts = useSelector(getDirtyProducts);
  const onConfirm = () => {
    const existingIndex = _.findIndex(products, (p) => p.product_sku === sku);
    if (existingIndex === -1) {
      const product = {};
      product.product_sku = sku;
      const newTab = createTab(product, TAB_TYPE_ENUM.NEW, '');
      dispatch(addTab(newTab));
      dispatch(setActiveTab(newTab));
      dispatch(fetchImagesInFolder(sku));
      setSku('');
    } else {
      message.error('SKU already exists');
    }
  };

  const handleUpdateGrid = () => {
    if (gridDirtyProducts.length === 0) {
      message.info('Nothing to update');
      return;
    }
    const stockPriceUpdates = gridDirtyProducts.map((p) => {
      return {
        product_sku: p.product_sku,
        enabled: p.enabled,
        stock: p.stock,
        offer_data: {
          AUD: {
            price: p.offer_data.AUD.price,
            kogan_first_price: p.offer_data.AUD.kogan_first_price,
            shipping: p.offer_data.AUD.shipping,
            handling_days: p.offer_data.AUD.handling_days,
            rrp: p.offer_data.AUD.rrp,
          },
        },
      };
    });
    updateStockPrice({ stockPriceUpdates: stockPriceUpdates })
      .then((resp) => {
        if (resp.data.success === true) {
          dispatch(clearDirtyProducts());
          message.success('Success! Stock & price updates saved to Kogan');
        } else {
          message.error(resp.data.message);
        }
      })
      .catch((error) => {
        message.error(error.message);
      });
  };

  const handleSKUChange = (event) => {
    setSku(event.target.value);
  };

  return (
    <Space.Compact block>
      <Popconfirm
        placement="right"
        title="Enter SKU"
        okText="OK"
        cancelText="Cancel"
        description={
          <Input
            name="sku"
            id="sku"
            type="text"
            onChange={handleSKUChange}
            value={sku}
          />
        }
        onConfirm={onConfirm}
      >
        <Button type="primary" icon={<PlusCircleTwoTone />}>
          {PRODUCT_BUTTON_ENUM.ADD}
        </Button>
      </Popconfirm>
      <Button
        type="primary"
        icon={<SaveOutlined />}
        ghost
        onClick={handleUpdateGrid}
      >
        {PRODUCT_BUTTON_ENUM.EDIT}
      </Button>
      <Button
        type="primary"
        icon={<ReloadOutlined />}
        onClick={() => dispatch(fetchProducts())}
        loading={fetchStatus}
      >
        {PRODUCT_BUTTON_ENUM.REFRESH}
      </Button>
    </Space.Compact>
  );
}

export default ButtonContainer;

export const PRODUCT_BUTTON_ENUM = {
  ADD: 'Add New Product',
  EDIT: 'Save Grid Changes',
  REFRESH: 'Refresh Grid',
};
